// import axios from 'axios'
import config from '@config'
import axios from './index'

/**  开票相关 */
// 获取可开发票总金额
// 获取金额 弃用
export const getTotalMoney = function (params) {
    return axios({
        method: 'get',
        params,
        url: config.ajaxUrl + '?_m=open_api&_a=get_invoice_order_money',
    })
}

// 获取提交开票数据是否开票成功
export const getUiStatus = function (params) {
    return axios({
        method: 'get',
        params,
        url: config.ajaxUrl + '?_m=open_api&_a=ui_status',
    })
}

// 获取行程订单列表 零担
export const getScheduleList = function (data) {
    return axios({
        method: 'post',
        data: data,
        url: config.ajaxUrl + '?_m=ltl_api&_a=get_order_list',
    })
}
// 获取行程订单列表 小b
export const getScheduleList_b = function (data) {
    return axios({
        method: 'post',
        data: data,
        url: config.ajaxUrl + '?_m=open_api&_a=get_order_list',
    })
}
// 获取抬头列表
export const getTitleList = function (data) {
    return axios({
        method: 'GET',
        url: config.ajaxUrl + '?_m=invoice_title_api&_a=invoice_title_list',
    })
}
// 开票
export const createInvoice = function (data) {
    return axios({
        method: 'post',
        data: data,
        url: config.ajaxUrl + '?_m=open_api&_a=apply_invoice',
    })
}
//检查是否认证资质
export const checkEpVerify = function (data) {
    return axios({
        method: 'post',
        data: data,
        url: config.ajaxUrl + '?_m=open_api&_a=check_ep_verify',
    })
}

//重发附件
export const invoiceAttach = function (data) {
    return axios({
        method: 'post',
        data: data,
        url: config.ajaxUrl + '?_m=push_api&_a=invoice_attach',
    })
}

// 专票资质申请
export const invoiceAuthApply = function (data) {
    return axios({
        method: 'post',
        data: data,

        url: config.ajaxUrl + '?_m=invoice_verify_api&_a=add_invoice_verify',
    })
}
// 编辑资质申请
export const editInvoiceAuthApply = function (data) {
    return axios({
        method: 'post',
        data: data,

        url: config.ajaxUrl + '?_m=invoice_verify_api&_a=edit_invoice_verify',
    })
}
// 获取资质详情
export const getInvoiceAuthDetail = function (invoice_type = 2) {
    return axios({
        method: 'get',
        params: { invoice_type },
        url: config.ajaxUrl + '?_m=invoice_verify_api&_a=get_verify_detail',
    })
}

// 天眼查
export const tianyancha = function (data) {
    return axios({
        method: 'POST',
        data: data,
        url: config.ajaxUrl + '?_m=open_api&_a=tyc_ep_info_search',
    })
}

export const tycEpInfo = function (data) {
    return axios({
        method: 'POST',
        data: data,
        url: config.ajaxUrl + '?_m=open_api&_a=tyc_ep_info',
    })
}


/** 地址管理相关 */
// 获取地址列表
export const getAddressList = function () {
    return axios({
        method: 'get',
        url: config.ajaxUrl + '?_m=address_api&_a=express_addr_list',
    })
}
// 新增地址
export const saveAddress = function (data) {
    return axios({
        method: 'post',
        data: data,

        url: config.ajaxUrl + '?_m=address_api&_a=add_express_addr',
    })
}
// 修改/删除地址
export const updateAddress = function (data) {
    return axios({
        method: 'post',
        data: data,

        url: config.ajaxUrl + '?_m=address_api&_a=edit_express_addr',
    })
}

/*** 支付相关  */
// 获取余额
export const getBalance = function () {
    return axios({
        method: 'GET',

        url: config.ajaxUrl + '?_m=wallet_api&_a=get_wallet_info',
    })
}
// 检查支付状态
export const checkPayStatus = function (orderNo) {
    return axios({
        method: 'GET',
        params: Object.assign({
            order_id: orderNo,
        }, {}),
        url: config.ajaxUrl + '?_m=wallet_api&_a=query_order_pay',


    })
}
// 兼容检查支付状态
export const queryExpressOrderPay = function (orderNo) {
    return axios({
        method: 'post',
        params: Object.assign({
            order_id: orderNo,
        }, {}),
        url: config.ajaxUrl + '?_m=wallet_api&_a=query_express_order_pay',


    })
}
// 支付 —— 类型 301 余额  113 支付宝  203 微信  302钱包
export const pay = function (data) {
    return axios({
        method: 'post',
        data: data,
        url: config.ajaxUrl + '?_m=wallet_api&_a=pay_express_fee',
    })
}

//安卓用户端用
export const createExpressOrderOld = function (data) {
    return axios({
        method: 'post',
        data: data,
        url: config.ajaxUrl + '?_m=wallet_api&_a=create_express_order_old',
    })
}



//获取支付链接
export const getCheckoutCounter = function (data) {
    return axios({
        method: 'post',
        data: data,
        url: config.ajaxUrl + '?_m=wallet_api&_a=create_express_order',
    })
}
//历史取消开票
export const setCancelExpress = function (data) {
    return axios({
        method: 'post',
        data: data,
        url: config.ajaxUrl + '?_m=wallet_api&_a=cancel_express_order',
    })
}
//开票取消开票
export const cancelExpressPay = function (data) {
    return axios({
        method: 'post',
        data: data,
        url: config.ajaxUrl + '?_m=wallet_api&_a=cancel_express_pay',
    })
}

//查询订单是否有未支付的
export const getExpressStatus = function (data) {
    return axios({
        method: 'post',
        data: data,
        url: config.ajaxUrl + '?_m=open_api&_a=check_express_status',
    })
}


/** 其他 */
// 获取发票规则配置
export const getConfig = function () {
    return axios({
        method: 'GET',
        url: config.ajaxUrl + '?_m=entrance_config_api&_a=a_entrance_conf_detail',
    })
}
// 获取客服入口配置
export const getCustomEntrance = function () {
    return axios({
        method: 'GET',
        url: config.ajaxUrl + '?_m=entrance_config_api&_a=a_customer_entrance',
    })
}
// 获取个人信息
export const getPersonInfo = function () {
    return axios({
        method: 'GET',

        url: config.ajaxUrl + '?_m=open_api&_a=get_user_info',
    })
}


// 获取发票规则
export const test = function () {
    return axios({
        method: 'GET',
        url: config.ajaxUrl + '?_m=test&_a=a_t13',
    })
}
/** 获取判断是否一次性开票 */

export const getOnceInvoice = function () {
    return axios({
        method: 'GET',
        url: config.ajaxUrl + '?_m=open_api&_a=get_total_invoice_history_nums',
    })
}

// 用户中心认证 
export const getPassport = function () {
    return axios({
        method: 'GET',
        url: config.ajaxUrl + '?_m=open_api&_a=get_access_token&user_type=2&entrance_type=1',
    })
}

// 发票详情
export const getInvoceInfo = function (data) {
    return axios({
        method: 'post',
        data: data,
        url: config.ajaxUrl + '?_m=open_api&_a=get_pre_invoice_info',
    })
}

// 收款凭证详情
export const getInvoceProofInfo = function (data) {
    return axios({
        method: 'post',
        data: data,
        url: config.ajaxUrl + '?_m=receipt_api&_a=get_receipt_preview',
    })
}

// 上传图片
export const uploadImg = function (data) {
    return axios({
        method: 'post',
        data: data,
        url: config.ajaxUrl + '?_m=common_api&_a=upload_file',
    })
}

// 获取城市
export const getCity = function (data) {
    return axios({
        method: 'post',
        data: data,
        url: config.ajaxUrl + '?_m=invoice_verify_api&_a=a_get_zone_info',
    })
}

// 预检查
export const preCheckStatus = function (data) {
    return axios({
        method: 'post',
        data: data,
        url: config.ajaxUrl + '?_m=open_api&_a=pre_check',
    })
}

// 城市列表
export const getCityList = function (data) {
    return axios({
        method: 'post',
        data: data,
        url: config.ajaxUrl + '?_m=common&_a=a_get_region_city_list',
    })
}
// 快递信息
export const getExpressInfo = function (track_no) {
    return axios({
        method: 'get',
        params: { track_no },
        url: config.ajaxUrl + '?_m=open_api&_a=express_info',
    })
}
// 获取所有行程单号
export const getTotalOrderNo_b = function (params) {
    return axios({
        method: 'get',
        params,
        url: config.ajaxUrl + '?_m=open_api&_a=get_order_nos',
    })
}
// 获取所有行程单号 零担
export const getTotalOrderNo = function (params) {
    return axios({
        method: 'get',
        params,
        url: config.ajaxUrl + '?_m=ltl_api&_a=get_order_nos',
    })
}
// 是否允许冲红
export const getRedStatus = function (invoice_no) {
    return axios({
        method: 'get',
        params: { invoice_no },
        url: config.ajaxUrl + '?_m=open_api&_a=check_invoice_reapply',
    })
}

// 发票详情
export const getInvoiceDetail = function (invoice_no) {
    return axios({
        method: 'post',
        data: { invoice_no },
        url: config.ajaxUrl + '?_m=open_api&_a=get_invoice_info',
    })
}
// 发票重开
export const createReopenInvoice = function (data) {
    return axios({
        method: 'post',
        data,
        url: config.ajaxUrl + '?_m=open_api&_a=reapply_invoice',
    })
}

// 释放行程单
export const releaseTrip = function (data) {
    return axios({
        method: 'post',
        data,
        url: config.ajaxUrl + '?_m=open_api&_a=release_trip',
    })
}


// 获取发票pdf
export const getPdfFile = function (params) {
    return axios({
        method: 'get',
        params,
        url: config.ajaxUrl + '?_m=common_api&_a=get_invoice_view',
    })
}

// 获取是否包含承运
export const getIncludeOrder = function (params) {
    return axios({
        method: 'get',
        url: config.ajaxUrl + '?_m=open_api&_a=check_cy_order',
    })
}

//批量发送行程单到邮箱
export const batchSendItinerary = function (params) {
    return axios({
        method: 'GET',
        params,
        url: config.ajaxUrl + '?_m=open_api&_a=batch_send_itinerary',
    })
}

// 下载收款凭证
export const receiptDownload = function (params) {
    return axios({
        method: 'GET',
        params,
        url: config.ajaxUrl + '?_m=receipt_api&_a=download',
    })
}

// 发送收款凭证到邮箱
export const receiptSend = function (params) {
    return axios({
        method: 'GET',
        params,
        url: config.ajaxUrl + '?_m=receipt_api&_a=send',
    })
}

// 收款凭证历史
export const receiptHistory = function (params) {
    return axios({
        method: 'GET',
        params,
        url: config.ajaxUrl + '?_m=receipt_api&_a=history',
    })
}

// 收款凭证订单全选
export const receiptAllSelect = function (params) {
    return axios({
        method: 'GET',
        params,
        url: config.ajaxUrl + '?_m=receipt_api&_a=all_select',
    })
}

// 收款凭证订单列表
export const receiptGetOrderList = function (params) {
    return axios({
        method: 'GET',
        params,
        url: config.ajaxUrl + '?_m=receipt_api&_a=get_order_list',
    })
}

// 申请收款凭证
export const receiptSave = function (params) {
    return axios({
        method: 'POST',
        params,
        url: config.ajaxUrl + '?_m=receipt_api&_a=save',
    })
}

// 查看收款凭证
export const receiptView = function (params) {
    return axios({
        method: 'GET',
        params,
        url: config.ajaxUrl + '/?_m=receipt_api&_a=view',
    })
}

// 收款凭证详情
export const receiptDetail = function (params) {
    return axios({
        method: 'GET',
        params,
        url: config.ajaxUrl + '/?_m=receipt_api&_a=detail',
    })
}

// 收款凭证订单列表
export const receiptGetOrder = function (params) {
    return axios({
        method: 'GET',
        params,
        url: config.ajaxUrl + '/?_m=receipt_api&_a=get_receipt_order',
    })
}


// WEBPACK FOOTER //
// ./src/axios/invoice.js